import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'PortfoliosIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    boxSize: 6,
  },
  path: (
    <path
      d="M20.25 11.25C20.25 10.0074 19.2426 9 18 9H14.25C14.25 10.6569 12.9069 12 11.25 12C9.59315 12 8.25 10.6569 8.25 9H4.5C3.25736 9 2.25 10.0074 2.25 11.25M20.25 11.25V17.25C20.25 18.4926 19.2426 19.5 18 19.5H4.5C3.25736 19.5 2.25 18.4926 2.25 17.25V11.25M20.25 11.25V8.25M2.25 11.25V8.25M20.25 8.25C20.25 7.00736 19.2426 6 18 6H4.5C3.25736 6 2.25 7.00736 2.25 8.25M20.25 8.25V5.25C20.25 4.00736 19.2426 3 18 3H4.5C3.25736 3 2.25 4.00736 2.25 5.25V8.25"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
      fill="none"
    />
  ),
});
